export const getAdminReturnTo = (value: unknown): string | undefined => {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    /[\\\u0000-\u0020\u007f]/.test(value)
  ) {
    return undefined;
  }

  try {
    const url = new URL(value, 'https://www.volvotechinfo.com');
    if (
      url.origin !== 'https://www.volvotechinfo.com' ||
      (url.pathname !== '/admin' && !url.pathname.startsWith('/admin/'))
    ) {
      return undefined;
    }

    return url.pathname + url.search + url.hash;
  } catch {
    return undefined;
  }
};
